import * as actions from '@app/actions/index';
import { IDashboardComponentProps } from '@app/models';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import AdminDashboardComponent from './admin-dashboard.component';

function mapStateToProps(authState: any): IDashboardComponentProps {
	return {
		intl: null,
		openSnackBar: null,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboardComponent);



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/admin-dashboard.ts